import { Search } from 'lucide-react'
import { AdasSearchMenu } from '@components/wrapper-components'
import PropTypes from 'prop-types'
import { AdasBox, AdasTextField, AdasInputAdornment } from '../wrapper-components'

const SearchWithSelect = ({ selectValue, onSelectChange, searchValue, onSearchChange, options, placeholder }) => {
  return (
    <AdasBox display='flex' alignItems='center' className='w-full md:w-auto flex-row items-center gap-2'>
      <AdasSearchMenu
        value={selectValue}
        onChange={onSelectChange}
        options={options}
        className='min-w-[100px] w-auto border border-border text-[14px] rounded-lg py-[6px] px-[12px] h-[40px] bg-card'
      />

      <AdasTextField
        value={searchValue}
        onChange={onSearchChange}
        placeholder={placeholder}
        variant='standard'
        InputProps={{
          disableUnderline: true,
          border: '0',
          startAdornment: (
            <AdasInputAdornment position='start'>
              <Search className='w-4 h-4' style={{ color: '#6B7280' }} />
            </AdasInputAdornment>
          )
        }}
        className='min-w-[160px] w-auto text-[14px] rounded-lg h-[40px]'
      />
    </AdasBox>
  )
}

SearchWithSelect.propTypes = {
  selectValue: PropTypes.string,
  onSelectChange: PropTypes.func,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string
}

export default SearchWithSelect
